import goggles from 'common/onboarding/immersive-onboarding/assets/goggles.webp';
import exploreNoEvents from 'common/onboarding/immersive-onboarding/assets/explore-no-events.webp';
import exploreCongratulations from 'common/onboarding/immersive-onboarding/assets/explore-congratulations.webp';
import companyKpisTemplate from 'common/onboarding/immersive-onboarding/assets/company_kpis_template.webp';
import featureLaunchTemplate from 'common/onboarding/immersive-onboarding/assets/feature_launch_template.webp';
import lifecycleCohortTemplate from 'common/onboarding/immersive-onboarding/assets/lifecycle_cohort_template.webp';
import marketingKpisTemplate from 'common/onboarding/immersive-onboarding/assets/marketing_kpis_template.webp';
import webAnalyticsTemplate from 'common/onboarding/immersive-onboarding/assets/web_analytics_template.webp';
import bannerImage from 'common/onboarding/immersive-onboarding/assets/events-banner-thumbnail.webp';
import friendlyX from 'common/onboarding/immersive-onboarding/assets/friendly-x.webp';
import welcomeCompanies from 'common/onboarding/immersive-onboarding/assets/welcome-companies.webp';
import welcomeDemo from 'common/onboarding/immersive-onboarding/assets/welcome-demo.webp';
import toggles from 'common/onboarding/immersive-onboarding/assets/toggles.webp';
import sendData from 'common/onboarding/immersive-onboarding/assets/send-data.webp';
import bq from 'common/onboarding/immersive-onboarding/assets/bq.svg';
import gtm from 'common/onboarding/immersive-onboarding/assets/googletag.svg';
import rudderstack from 'common/onboarding/immersive-onboarding/assets/rudderstack.svg';
import snowflake from 'common/onboarding/immersive-onboarding/assets/snowflake.svg';
import segment from 'common/onboarding/immersive-onboarding/assets/segment.svg';
import more from 'common/onboarding/immersive-onboarding/assets/more.svg';
import js from 'common/onboarding/immersive-onboarding/assets/JS.svg';
import android from 'common/onboarding/immersive-onboarding/assets/android.svg';
import ios from 'common/onboarding/immersive-onboarding/assets/iOS.svg';
import eventListenerGif from 'common/onboarding/immersive-onboarding/assets/events-heart-beat.gif';
import eventDetected from 'common/onboarding/immersive-onboarding/assets/events-detected.svg';
import checkmark from 'common/onboarding/immersive-onboarding/assets/checkmark.svg';
import spot from 'common/onboarding/immersive-onboarding/assets/spot.webp';
import readyToConnect from 'common/onboarding/immersive-onboarding/assets/ready-to-connect-v2.riv';
import demoVideoThumbnail from 'common/onboarding/immersive-onboarding/assets/demo-video-thumbnail@2x.webp';
import wave from 'common/onboarding/immersive-onboarding/assets/wave.riv';
import tableHeaderGradient from 'common/onboarding/immersive-onboarding/assets/table-header-gradient.webp';
import summaryCheckmark from 'common/onboarding/immersive-onboarding/assets/summary-checkmark.webp';
import duplicate from 'common/onboarding/immersive-onboarding/assets/duplicate.svg';
import help from 'common/onboarding/immersive-onboarding/assets/help.svg';
import personalizeStepGradient from 'common/onboarding/immersive-onboarding/assets/personalize-step-gradient.webp';
import connectDataGradient from 'common/onboarding/immersive-onboarding/assets/connect-data-gradient.webp';
import ligthningBolt from 'common/onboarding/immersive-onboarding/assets/lightning-bolt.webp';
import clipboardCheckboxes from 'common/onboarding/immersive-onboarding/assets/clipboard-checkboxes.webp';
import reactNative from 'common/onboarding/immersive-onboarding/assets/react-native.svg';
import redshift from 'common/onboarding/immersive-onboarding/assets/redshift.svg';
import eventListener from 'common/onboarding/immersive-onboarding/assets/live-data.riv';

export const IMMERSIVE_ASSETS = {
  bannerImage,
  friendlyX,
  welcomeCompanies,
  welcomeDemo,
  toggles,
  goggles,
  exploreNoEvents,
  exploreCongratulations,
  companyKpisTemplate,
  featureLaunchTemplate,
  lifecycleCohortTemplate,
  marketingKpisTemplate,
  webAnalyticsTemplate,
  sendData,
  bq,
  gtm,
  rudderstack,
  snowflake,
  segment,
  more,
  js,
  android,
  ios,
  eventListenerGif,
  eventDetected,
  checkmark,
  spot,
  readyToConnect,
  demoVideoThumbnail,
  wave,
  tableHeaderGradient,
  summaryCheckmark,
  duplicate,
  help,
  personalizeStepGradient,
  connectDataGradient,
  ligthningBolt,
  clipboardCheckboxes,
  reactNative,
  redshift,
  eventListener,
};
